import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faBook,
  faFileLines,
  faHeadphones,
  faLink,
  faPoll,
  faVideo,
} from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ICON_SECONDARY } from '../../../theme';

type ContentType =
  | 'Video'
  | 'Audio'
  | 'Article'
  | 'ClickThroughMedia'
  | 'ContentSection'
  | 'InAppSurvey'
  | 'Link'
  | 'PracticeProgram'
  | 'Program'
  | 'Banner';

const contentTypeIconMap: Record<ContentType, IconProp> = {
  Video: faVideo,
  Audio: faHeadphones,
  Article: faFileLines,
  ClickThroughMedia: faVideo,
  ContentSection: faBook,
  InAppSurvey: faPoll,
  Link: faLink,
  PracticeProgram: faBook,
  Program: faBook,
  Banner: faBook, // don't think this is used
};

export const ContentTypeIcon = ({ typename }: { typename?: ContentType }) => {
  if (typeof typename !== 'string') {
    return null;
  }

  const icon = contentTypeIconMap[typename];
  return <FontAwesomeIcon icon={icon} fontSize={14} color={ICON_SECONDARY} />;
};
